import Vue from 'vue'
import VueRouter from 'vue-router'
import MainPage from '../views/MainPage2025.vue'
import SurveyLincLogistics from '../views/SurveyLincLogistics2025.vue'
import SurveyLincExpress from '../views/SurveyLincExpress2025.vue'
import SurveyLincImpex from '../views/SurveyLincImpex2025.vue'
import SurveyLincTerminal from '../views/SurveyLincTerminal2025.vue'
import LastPage from '../views/LastPage2025.vue'
import ThankYou from '../views/ThankYou.vue'
import NotFound from '../views/NotFound.vue'
import WelcomePage from '../views/WelcomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    meta: {
      title: "Linc Customer Survey",
      allowAnonymous: true,
    },
    name: "WelcomePage",
    component: WelcomePage,
  },
  {
    path: '/survey/:id',
    name: 'MainPage',
    component: MainPage
  },
  {
    path: '/survey-linc-logistics/:id',
    name: 'SurveyLincLogistics',
    component: SurveyLincLogistics
  },
  {
    path: '/survey-linc-express/:id',
    name: 'SurveyLincExpress',
    component: SurveyLincExpress
  },
  {
    path: '/survey-linc-impex/:id',
    name: 'SurveyLincImpex',
    component: SurveyLincImpex
  },
  {
    path: '/survey-linc-terminal/:id',
    name: 'SurveyLincTerminal',
    component: SurveyLincTerminal
  },
  {
    path: '/survey-last/:id',
    name: 'LastPage',
    component: LastPage
  },
  {
    path: '/done',
    name: 'ThankYou',
    component: ThankYou
  },
  {
    path: '*',
    meta: {
      title: "Linc Middleware"
    },
    name: "PageNotFoundArea",
    component: NotFound
  },
  {
    path: '/page-not-found',
    meta: {
      title: "Linc Middleware",
      allowAnonymous: true
    },
    name: "PageNotFound",
    component: NotFound
  },
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
